<div class="row">
  <div class="col-12">
    <div class="d-flex justify-content-between align-items-baseline">
      <div>
        <h5 class="mb-0 mt-0" translate>SAFEGUARD_SETTINGS</h5>
        <span class="font-italic small mb-2 d-inline-block" translate>SAFEGUARD_SETTINGS_DESCRIPTION</span>
      </div>
      <button class="btn btn-default" style="font-size: 20px;" (click)="save()">
        <i ngbTooltip="{{'SAVE' | translate}}" class="fas fa-save"></i>
      </button>
    </div>
  </div>
</div>

@if (loaded) {
  <div class="row mt-2">
    <div class="col-12 col-md-3">
      <lib-gung-checkbox-input-horizontal
        [(ngModel)]="configuration.enabled"
        gungTranslate="SAFEGUARD_ENABLED"
      />
    </div>
  </div>

  @if (configuration.enabled) {
    <!-- Per-run limits -->
    <h6 class="mt-4 mb-1" translate>PER_RUN_LIMITS</h6>
    <div class="row">
      <div class="col-12 col-md-3">
        <lib-gung-number-input
          [(ngModel)]="configuration.maxPaymentCountPerRun"
          gungTranslate="MAX_PAYMENT_COUNT_PER_RUN"
          [minValue]="0"
        />
      </div>
      <div class="col-12 col-md-3">
        <lib-gung-number-input
          [(ngModel)]="configuration.maxTotalAmountPerRun"
          gungTranslate="MAX_TOTAL_AMOUNT_PER_RUN"
          [minValue]="0"
        />
      </div>
      <div class="col-12 col-md-3">
        <lib-gung-number-input
          [(ngModel)]="configuration.maxSinglePaymentAmount"
          gungTranslate="MAX_SINGLE_PAYMENT_AMOUNT"
          [minValue]="0"
        />
      </div>
    </div>

    <!-- Anomaly detection -->
    <h6 class="mt-4 mb-1" translate>ANOMALY_DETECTION</h6>
    <div class="row">
      <div class="col-12 col-md-3">
        <lib-gung-checkbox-input-horizontal
          [(ngModel)]="configuration.anomalyDetectionEnabled"
          gungTranslate="ANOMALY_DETECTION_ENABLED"
        />
      </div>
      @if (configuration.anomalyDetectionEnabled) {
        <div class="col-12 col-md-3">
          <lib-gung-number-input
            [(ngModel)]="configuration.anomalyMultiplier"
            gungTranslate="ANOMALY_MULTIPLIER"
            [decimals]="1"
            [stepAmount]="0.1"
            [minValue]="0"
          />
        </div>
        <div class="col-12 col-md-3">
          <lib-gung-number-input
            [(ngModel)]="configuration.anomalyLookbackRuns"
            gungTranslate="ANOMALY_LOOKBACK_RUNS"
            [minValue]="1"
          />
        </div>
      }
    </div>

    <!-- Cumulative limits -->
    <h6 class="mt-4 mb-1" translate>CUMULATIVE_LIMITS</h6>
    <div class="row">
      <div class="col-12 col-md-3">
        <lib-gung-number-input
          [(ngModel)]="configuration.maxDailyAmount"
          gungTranslate="MAX_DAILY_AMOUNT"
          [minValue]="0"
        />
      </div>
      <div class="col-12 col-md-3">
        <lib-gung-number-input
          [(ngModel)]="configuration.maxWeeklyAmount"
          gungTranslate="MAX_WEEKLY_AMOUNT"
          [minValue]="0"
        />
      </div>
    </div>

    <!-- Override settings -->
    <h6 class="mt-4 mb-1" translate>OVERRIDE_SETTINGS</h6>
    <div class="row">
      <div class="col-12 col-md-3">
        <lib-gung-number-input
          [(ngModel)]="configuration.overrideValidityMinutes"
          gungTranslate="OVERRIDE_VALIDITY_MINUTES"
          [minValue]="1"
        />
      </div>
    </div>

    <!-- Dry run -->
    <div class="mt-3">
      <button class="btn btn-outline-primary" (click)="runDryRun()" [disabled]="dryRunLoading">
        <i class="fas fa-play me-1"></i>
        {{ 'DRY_RUN' | translate }}
        @if (dryRunLoading) {
          <i class="fas fa-spinner fa-spin ms-1"></i>
        }
      </button>

      @if (dryRunResult) {
        <div class="mt-2">
          @if (dryRunResult.passed) {
            <div class="alert alert-success mb-2">
              <i class="fas fa-check-circle me-1"></i>
              {{ 'DRY_RUN_PASSED' | translate }}
              — {{ dryRunResult.paymentCount }} {{ 'PAYMENTS' | translate }}, {{ dryRunResult.totalAmount | number:'1.2-2' }}
            </div>
          } @else {
            <div class="alert alert-danger mb-2">
              <i class="fas fa-exclamation-triangle me-1"></i>
              {{ 'DRY_RUN_FAILED' | translate }}
              — {{ dryRunResult.paymentCount }} {{ 'PAYMENTS' | translate }}, {{ dryRunResult.totalAmount | number:'1.2-2' }}
            </div>
            <ul class="list-group">
              @for (violation of dryRunResult.violations; track violation.type) {
                <li class="list-group-item list-group-item-danger">
                  <strong>{{ violation.type }}</strong>: {{ violation.message }}
                </li>
              }
            </ul>
          }
        </div>
      }
    </div>
  }
}
